import { z } from "zod";

export const loginSchema = z.object({
  email: z.string().email().min(1),
  password: z.string().min(6),
}).transform((data) => ({
  username: data.email,
  password: data.password,
}));

export type LoginFormValues = z.infer<typeof loginSchema>;
